// covered-by: frontends/carrie/src/ask-v2/pages/__tests__/AskV2ProjectPage.test.tsx
import { Heading, Text } from "@radix-ui/themes";
import { useTranslation } from "react-i18next";

type AskV2ProjectPageProps = {
  projectId: string;
};

export function AskV2ProjectPage({ projectId }: AskV2ProjectPageProps) {
  const { t } = useTranslation("ui");

  return (
    <div
      data-testid="ask-v2-project-page"
      className="flex min-h-0 w-full flex-1 flex-col gap-3 px-6 py-8"
    >
      <Heading as="h2" size="4">
        {t("askV2.pages.project.title")}
      </Heading>
      <Text as="p" size="2" className="text-puntt-neutral-gray-11">
        {t("askV2.pages.project.placeholder")}
      </Text>
      <Text as="p" size="1" data-testid="ask-v2-project-id">
        {projectId}
      </Text>
    </div>
  );
}
